/**
 * Books-only entry point from MoneyBook.
 * When workflow app is opened with ?entry=books (e.g. from moneybook.ai), we store it
 * and use it to filter nav to only Books group and redirect / to /books/accounts.
 */

const STORAGE_KEY = 'moneybook_entry';

export function getBooksEntry(): 'books' | null {
    if (typeof window === 'undefined') return null;
    const fromStorage = sessionStorage.getItem(STORAGE_KEY);
    if (fromStorage === 'books') return 'books';
    const params = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    if (params.get('entry') === 'books' || hashParams.get('entry') === 'books') {
        sessionStorage.setItem(STORAGE_KEY, 'books');
        return 'books';
    }
    return fromStorage === 'books' ? 'books' : null;
}

export function setBooksEntry(entry: 'books' | null): void {
    if (typeof window === 'undefined') return;
    if (entry) sessionStorage.setItem(STORAGE_KEY, entry);
    else sessionStorage.removeItem(STORAGE_KEY);
}

export function clearBooksEntry(): void {
    setBooksEntry(null);
}
